
import React, { Component } from "react";
import { Input, Checkbox, Button, Box, HStack, Spacer, Select} from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSyncAlt } from "@fortawesome/free-solid-svg-icons";
import _clone from 'lodash/cloneDeep';

import LocalStorageService from "../../../../services/LocalStorageService";
import CoreService from "../../../../services/CoreService";

import LookupEntityManager from "../Managers/LookupEntityManager";






export default class LookupEntityInput extends Component 
{
    constructor(props) {
        super(props);

        this.state = {
            valid: true,
            inputValue: "",
            value: [],
            descript: "",
            lookupButtonEnabled: false,
            inLookup: false,
            lookupError: false,
            lookupErrMsg: "",
            isToggled: false,
            duplicateEntityKeyData: null
        }

        this.LocalStorageService = new LocalStorageService();
        this.coreService = new CoreService();

        this.onValueChange = this.onValueChange.bind(this);
        this.onToggleClick = this.onToggleClick.bind(this);
        this.onLookupButtonClick = this.onLookupButtonClick.bind(this);
        this.onDuplicateEntityKeySelection = this.onDuplicateEntityKeySelection.bind(this);

    }

    componentDidUpdate(prevProps)
    {
        if (prevProps.cardValue !== this.props.cardValue)
        {
            var lookupEnabled = ((this.props.cardValue) && (this.props.cardValue.length > 0));
            this.setState({lookupButtonEnabled: lookupEnabled, lookupErrMsg: ""});
        }
    }

    onValueChange(e) 
    {
        this.props.onValueChange(e.target.value, this.props.card.id);
    }


    onToggleClick(e)
    {
        if (e.target.checked)
        {
            this.props.onSaveLookupEntity(this.props.card.id, this.props.cardValue);
        }
        else
        {
            this.props.onRemoveLookupEntity(this.props.card.id);
           
        }
    }

    async onDuplicateEntityKeySelection(e)
    {
        
        var lookupEntityId = e.target.value;
        var lookupEntityCardSchema = LookupEntityManager.getLookupEntityCardSchema(this.props.schema, this.props.card.id);
        var lookupResponse;

        if (this.props.onlineInfo.isConnected)
        {
            lookupResponse = await this.coreService.fetchLookupEntityById(this.props.card.id, lookupEntityCardSchema, lookupEntityId, this.props.gcid, this.props.token);
        }
        else 
        {
            lookupResponse = this.LocalStorageService.getLookupEntity(this.props.card.id, lookupEntityId, this.props.gcid);
        }
        
  
        var mapData = lookupResponse.dataResult.data;
        mapData.forEach((d) => 
        {
            this.props.onValueChange(d.value, d.id, false);
        })
        // set the id of the lookup entity in case we are deleting on use
        if (lookupEntityCardSchema.deleteOnUse)
        {
            var newLookupEntityIdList = (this.props.valueBag.lookupEntityIdList) ? 
                this.props.valueBag.lookupEntityIdList
                : {};
            // we can only have ONE per card id. It's possible that the user has selected one, then changed their mind and selected another We don't
            // want to remove the one we have selected initially and changed.
            newLookupEntityIdList[this.props.card.id] = lookupResponse.dataResult.metaData.id;
            this.props.onValueChange(newLookupEntityIdList, "lookupEntityIdList", false);
        }
        this.setState({duplicateEntityKeyData: null});

    }

    async onLookupButtonClick(e)
    {
        try
        {
            this.setState({inLookup: true});
            var lookupResponse;
            var lookupEntityCardSchema = LookupEntityManager.getLookupEntityCardSchema(this.props.schema, this.props.card.id);
            var schemaId = this.props.schema.schemaInfo.id;
            if (this.props.onlineInfo.isConnected)
            {
                lookupResponse = await this.coreService.fetchLookupEntityByKey(this.props.card.id, schemaId, this.props.cardValue, lookupEntityCardSchema, this.props.gcid, this.props.token);
            }
            else 
            {
                lookupResponse = this.LocalStorageService.getLookupEntity(this.props.card.id, this.props.cardValue, this.props.gcid);
            }
            if (lookupResponse.hasError)
            {
                var msg = lookupResponse.messages.join(" ");
                this.setState({lookupErrMsg: msg});
                return;
            }
            else if (lookupResponse.dataResult.length < 1)
            {
                var msg = "It appears that this lookup entity has not been saved yet.";
                this.setState({lookupErrMsg: msg});
                return;
            }

            // filter by the CURRENT schema
            var currentSchemaId = this.props.schema.schemaInfo.id;
            var lookupData = lookupResponse.dataResult.filter((l) => l.metaData.schemaId === currentSchemaId);

            if (lookupData.length > 1)
            {
                var duplicateEntityKeyData = lookupData.map((d) => {return {id: d.metaData.id, value: d.metaData.identifier}});
                this.setState({duplicateEntityKeyData: duplicateEntityKeyData});
                //var msg = "Multiple possible values found for " + this.props.cardValue + ". Select your choice from dropdown.";
                //this.setState({lookupErrMsg: msg});
                return;
            }
            else 
            {
                var mapData = lookupData[0].data;
                mapData.forEach((d) => 
                {
                    this.props.onValueChange(d.value, d.id, false);
                })
            }

        }
        finally{
            this.setState({inLookup: false});

        }
    }

    render() {

        return (
            <Box>
            <HStack >
                <Input
                    autoFocus
                    backgroundColor={"white"}
                    placeholder={this.props.card.attribTitle}
                    name={this.props.card.Id}
                    value={this.props.cardValue}
                    onChange={this.onValueChange}
                />
                <Spacer />

                {this.props.onlineInfo.isConnected &&
                <Checkbox 
                colorScheme='green' 
                isDisabled={!this.state.lookupButtonEnabled} 
                onChange={(e) => this.onToggleClick(e)}
                color="white"
                isChecked={this.props.lookupEntityBag[this.props.card.id] ? true : false}
                >
                    Save
                </Checkbox>
                }

                <Button className="lookup-button"
                    isDisabled={this.props.cardValue ? false : true}
                    onClick={this.onLookupButtonClick}
                    fontColor={(this.state.lookupError) ? "yellow" : "white"}
                    rightIcon={(this.state.inLookup) ? <FontAwesomeIcon icon={faSyncAlt} color="lightgreen" spin={true} /> : <span />}
                >
                    Lookup
                </Button>
                <div align="center" style={{ color: "yellow", fontSize: "10px"}}>
                    {this.state.lookupErrMsg}
                </div>
            </HStack>


            {(this.state.duplicateEntityKeyData) &&
            <HStack>
                <Select 
                    margin="10px"
                    variant="filled"
                    placeholder='Select  a single Lookup Entity Value' 
                    onChange={(e) => this.onDuplicateEntityKeySelection(e)}
                >
                    {this.state.duplicateEntityKeyData.map((d) =>  <option value={d.id}>{d.value}</option>)}
                </Select>
            </HStack>
            }


            </Box>
        );
    }
}







